import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { browserLeaveTips } from "@/utils/common";
import {
  OLD_USER_CENTER_SEARCH_URL,
  USER_CENTER_SEARCH_URL,
  USER_CENTER_URL,
  SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL,
  OLD_SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL,
  SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_URL,
  BUSINESS_OPPORTUNITY_URL,
  SUBSCRIBE_CENTER_URL,
  TRADE_CENTER_URL,
  ACCOUNT_MANAGE_URL,
  ROUTE_LEAVE_CONFIRM,
} from "@/utils/constants/constants.menu";
import { HEADER_CUSTOM_ID, HEADER_TYPE, OLD_USER_CENTER_URL } from "@/utils/constants/constants";
import systemInit from "@/utils/system";
import { LibMsgBox } from "qlmbidding2_pc_lib";
import { AUTO_BAY_NAMESPACE } from "@/utils/constants/constants.layout";
// import { stationWideStatistics } from "@/utils/statistics-link";

/** 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错 **/
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

/**
 * 标准：但凡需要query参数的路由，都必须是路由最后一级，该路由下不能有children，避免面包屑点击的逻辑漏洞
 * **/
const routes = [
  /** 会员中心 **/
  {
    path: "/user-center",
    component: () => import("@/views/UserCenter/Index"),
    meta: {
      breadcrumb: { name: "会员中心" },
      header: {
        type: HEADER_TYPE.SEARCH,
      },
      sidebar: { show: true, auto_bay: [] },
      isShowFooter: true,
    },
    children: [
      /** 首页 **/
      {
        path: "index", // 必须+index，否则会影响当前菜单高亮
        name: "首页",
        component: () => import("@/views/UserCenter/HomeView"),
        meta: {
          isShowMenu: true,
          isShowSidebarDownloadGuide: true, //是否显示下载app横栏
          breadcrumb: { name: "首页" },
          needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
        },
      },
      /** 我的会员 **/
      {
        path: "my",
        name: "我的会员",
        component: () => import("@/views/UserCenter/My.vue"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "我的会员" },
          needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
        },
      },
      /** 搜索 **/
      {
        path: "search",
        name: "搜索",
        component: () => import("@/views/UserCenter/SearchView"),
        meta: {
          isShowMenu: false,
          breadcrumb: { name: "搜索" },
          needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
        },
      },
      {
        path: "questionnaire-investigation",
        name: "千里马产品使用调研",
        component: () => import("@/views/UserCenter/QuestionnaireInvestigation/Index.vue"),
        meta: {
          useLayout: false,
          needAsyncBasicDataInit: false,
        },
      },
      /** 通配，避免 /user-center、/user-center/ 无法访问 **/
      {
        path: "/",
        name: "",
        meta: {
          redirect_url: USER_CENTER_URL, // 用在了路由守卫处
        },
      },
      {
        path: "*",
        name: "",
        meta: {
          redirect_url: USER_CENTER_URL, // 用在了路由守卫处
        },
      },
    ],
  },
  /** 找商机 **/
  {
    path: "/business-opportunity",
    component: () => import("@/views/BusinessOpportunity/Index"),
    meta: {
      breadcrumb: { name: "找商机" },
      header: {
        type: HEADER_TYPE.SEARCH,
      },
      isShowFooter: true,
      needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
    },
    children: [
      {
        path: "purchase-intention",
        name: "采购意向",
        component: () => import("@/views/BusinessOpportunity/PurchaseIntentionView.vue"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "采购意向" },
          sidebar: { show: true, auto_bay: [] },
        },
      },
      {
        path: "bidding-info",
        name: "标讯",
        component: () => import("@/views/BusinessOpportunity/BiddingInfoView"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "标讯" },
          sidebar: { show: true, auto_bay: [AUTO_BAY_NAMESPACE.HELP_CENTER_BIDDING_INFO] },
        },
      },
      {
        path: "constr-project",
        name: "拟在建项目",
        component: () => import("@/views/BusinessOpportunity/ConstrProjectView.vue"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "拟在建项目" },
          sidebar: { show: true, auto_bay: [AUTO_BAY_NAMESPACE.HELP_CENTER_CONSTR_PROJECT] },
        },
      },
      {
        path: "examine-project",
        name: "审批项目",
        component: () => import("@/views/BusinessOpportunity/ExamineProjectView.vue"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "审批项目" },
          sidebar: { show: true, auto_bay: [AUTO_BAY_NAMESPACE.HELP_CENTER_EXAMINE_PROJECT] },
        },
      },
    ],
  },
  /** 订阅中心 **/
  {
    path: "/subscribe-center",
    component: () => import("@/views/SubscribeCenter/Index"),
    meta: {
      breadcrumb: { name: "订阅中心", disabled: true },
      header: {
        type: HEADER_TYPE.SEARCH,
      },
      isShowFooter: true,
      needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
      sidebar: { show: true, auto_bay: [] },
    },
    children: [
      /** 新增订阅 **/
      {
        path: "subscribe-create",
        name: "新增订阅",
        component: () => import("@/views/SubscribeCenter/SubscribeCreate/Index"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "新增订阅", disabled: true },
        },
        children: [
          /** 新增订阅 - 标讯订阅器创建 **/
          {
            path: "bidding-info",
            name: "标讯订阅器创建",
            component: () => import("@/views/SubscribeCenter/SubscribeCreate/BiddingInfoView.vue"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "标讯订阅器创建" },
            },
          } /** 新增订阅 - 标讯订阅器创建 **/,
          {
            path: "purchase-intention",
            name: "采购意向订阅器创建",
            component: () => import("@/views/SubscribeCenter/SubscribeCreate/PurchaseIntentionView.vue"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "采购意向订阅器创建" },
            },
          },
        ],
      },
      /** 订阅信息 **/
      {
        path: "subscribe-info",
        name: "订阅信息",
        component: () => import("@/views/SubscribeCenter/SubscribeInfo/Index"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "订阅信息", disabled: true },
        },
        children: [
          /** 订阅信息 - 标讯订阅 **/
          {
            path: "bidding-info",
            name: "标讯订阅",
            component: () => import("@/views/SubscribeCenter/SubscribeInfo/BiddingInfoView.vue"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "标讯订阅" },
              sidebar: { show: true, auto_bay: [AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_BIDDING_INFO] },
            },
          },
          /** 订阅信息 - 拟在建订阅 **/
          {
            path: "constr-project",
            name: "拟在建订阅",
            component: () => import("@/views/SubscribeCenter/SubscribeInfo/ConstrProjectView.vue"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "拟在建订阅" },
              sidebar: { show: true, auto_bay: [AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_CONSTR_PROJECT] },
            },
          },
          /** 订阅信息 - 审批订阅 **/
          {
            path: "examine-project",
            name: "审批订阅",
            component: () => import("@/views/SubscribeCenter/SubscribeInfo/ExamineProjectView.vue"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "审批订阅" },
              sidebar: { show: true, auto_bay: [AUTO_BAY_NAMESPACE.HELP_CENTER_SUB_EXAMINE_PROJECT] },
            },
          }, //
          /** 订阅信息 -采购意向 **/
          {
            path: "purchase-intention",
            name: "采购意向订阅",
            component: () => import("@/views/SubscribeCenter/SubscribeInfo/PurchaseIntentionView.vue"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "采购意向订阅" },
              sidebar: { show: true, auto_bay: [] },
            },
          },
        ],
      },
      /** 订阅管理 **/
      {
        path: "subscribe-manage",
        name: "订阅管理",
        component: () => import("@/views/SubscribeCenter/SubscribeManage/Index"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "订阅管理" },
        },
        children: [
          /** 订阅管理 - 标讯订阅器配置 **/
          {
            path: "bidding-info",
            name: "标讯订阅器配置",
            component: () => import("@/views/SubscribeCenter/SubscribeManage/BiddingInfoView.vue"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "标讯订阅器配置" },
            },
          },
          /** 订阅管理 - 采购意向订阅器配置 **/
          {
            path: "purchase-intention",
            name: "采购意向订阅器配置",
            component: () => import("@/views/SubscribeCenter/SubscribeManage/PurchaseIntentionView.vue"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "采购意向订阅器配置" },
            },
          },
        ],
      },
    ],
  },
  /** 企业监控 **/
  {
    path: "/enterprise-monitoring",
    component: () => import("@/views/EnterpriseMonitoring/Index"),
    meta: {
      breadcrumb: { name: "全部应用" },
      header: {
        type: HEADER_TYPE.SEARCH,
      },
      isShowMenu: true,
      isShowFooter: true,
      needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
    },
    children: [
      // {
      //   path: "monitoring-permission",
      //   name: "企业监控没有权限",
      //   component: () => import("@/views/EnterpriseMonitoring/MonitoringNoPermissionView"),
      //   meta: {
      //     isShowMenu: true,
      //     breadcrumb: { name: "企业监控" },
      //     sidebar: { show: true, auto_bay: [] },
      //   },
      // },
      {
        path: "monitoring-dynamics",
        name: "企业动态",
        component: () => import("@/views/EnterpriseMonitoring/MonitoringDynamicsView"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "企业监控" },
          sidebar: { show: true, auto_bay: [] },
        },
      },
      {
        path: "monitoring-list",
        name: "企业列表",
        component: () => import("@/views/EnterpriseMonitoring/MonitoringListView"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "企业监控" },
          sidebar: { show: true, auto_bay: [] },
        },
      },
      {
        path: "monitoring-settings",
        name: "监控设置",
        component: () => import("@/views/EnterpriseMonitoring/MonitorSettingsView"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "企业监控" },
          sidebar: { show: true, auto_bay: [] },
        },
      },
    ],
  },
  /** 交易中心 **/
  {
    path: "/trade-center",
    component: () => import("@/views/TradeCenter/Index"),
    meta: {
      breadcrumb: { name: "交易中心" },
      header: {
        type: HEADER_TYPE.SEARCH,
      },
      sidebar: { show: true, auto_bay: [] },
      isShowFooter: true,
      needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
    },
    children: [
      /** 发票管理 **/
      {
        path: "invoice-manage",
        component: () => import("@/views/TradeCenter/InvoiceManage/Index"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "发票管理" },
        },
        children: [
          /** 发票管理 **/
          {
            path: "/",
            name: "发票管理",
            component: () => import("@/views/TradeCenter/InvoiceManage/InvoiceManageView"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "" },
            },
          },
          /** 发票管理 - 发票服务 **/
          {
            path: "invoice-service",
            name: "发票服务",
            component: () => import("@/views/TradeCenter/InvoiceManage/InvoiceServiceView"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "发票服务" },
            },
          },
          /** 发票管理 - 申请开票 **/
          {
            path: "invoice-apply",
            name: "申请开票",
            component: () => import("@/views/TradeCenter/InvoiceManage/InvoiceApplyView"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "申请开票" },
            },
          },
        ],
      },
    ],
  },
  /** 企业管理 **/
  {
    path: "/enterprise-manage",
    component: () => import("@/views/EnterpriseManage/Index"),
    meta: {
      breadcrumb: { name: "企业管理", disabled: true },
      header: {
        type: HEADER_TYPE.SEARCH,
      },
      sidebar: { show: true, auto_bay: [] },
      isShowFooter: true,
      needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态
    },
    children: [
      {
        path: "sub-account",
        name: "子账号管理",
        component: () => import("@/views/EnterpriseManage/SubAccount/Index"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "子账号管理" },
        },
        children: [
          {
            path: "/",
            name: "子账号管理",
            component: () => import("@/views/EnterpriseManage/SubAccount/SubContentView"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "" },
            },
          },
          {
            path: "revise-quota",
            name: "账号访问额度配置",
            component: () => import("@/views/EnterpriseManage/SubAccount/ReviseQuotaView"),
            meta: {
              isShowMenu: true,
              breadcrumb: { name: "账号访问额度配置", isShowBack: true },
            },
          },
        ],
      },
    ],
  },
  /** 账户管理 **/
  {
    path: "/account-manage",
    component: () => import("@/views/AccountManage/Index"),
    meta: {
      breadcrumb: { name: "账户管理" },
      header: {
        type: HEADER_TYPE.SEARCH,
      },
      sidebar: { show: true, auto_bay: [] },
      isShowFooter: true,
      needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
    },
    children: [
      {
        path: "account-info",
        name: "账号信息",
        component: () => import("@/views/AccountManage/AccountInfoView"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "账号信息" },
        },
      },
      {
        path: "modify-password",
        name: "修改密码",
        component: () => import("@/views/AccountManage/ModifyPasswordView"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "修改密码" },
        },
      },
      {
        path: "account-security",
        name: "账户安全",
        component: () => import("@/views/AccountManage/AccountSecurityView"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "账户安全" },
        },
      },
    ],
  },
  /** 使用手册 **/
  {
    path: "/product-manual",
    component: () => import("@/views/ProductManual/Index"),
    meta: {
      header: {
        type: HEADER_TYPE.CUSTOM,
        options: {
          customId: HEADER_CUSTOM_ID.PRODUCT_MANUAL,
        },
      },
      isShowMenu: false,
      sidebar: { show: true, auto_bay: [] },
      isShowFooter: false,
      needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
    },
    children: [
      {
        path: "/",
        name: "使用手册",
        component: () => import("@/views/ProductManual/ProductManual"),
        meta: {
          isShowMenu: false,
          breadcrumb: { name: "" },
        },
      },
    ],
  },
  /** iframe **/
  {
    path: "/iframe/:name",
    name: "iFrame",
    component: () => import("@/views/IFrame/Index"),
    meta: {
      header: {},
      sidebar: { show: false },
      isShowFooter: false,
      needAsyncBasicDataInit: false, // 需要初始化基础信息(登录态)
    },
  },
  /** 重置密码 **/
  {
    path: "/reset-password",
    component: () => import("@/views/ResetPassword/Index"),
    meta: {
      header: {
        type: HEADER_TYPE.CUSTOM,
        options: {
          customId: HEADER_CUSTOM_ID.DEFAULT,
        },
      },
      isShowMenu: false,

      sidebar: { show: false },
      isShowFooter: true,
      needAsyncBasicDataInit: false, // 需要初始化基础信息(登录态)
    },
    children: [
      {
        path: "/",
        name: "找回密码",
        component: () => import("@/views/ResetPassword/HomeView"),
        meta: {},
      },
      {
        path: "process",
        name: "安全验证 & 设置密码",
        component: () => import("@/views/ResetPassword/Process"),
        meta: {},
      },
    ],
  },
  /** 登录 **/
  {
    path: "/loginBackups",
    component: () => import("@/views/LoginBackups/Index"),
    name: "登录",
    meta: {
      header: {
        type: HEADER_TYPE.CUSTOM,
        options: {
          customId: HEADER_CUSTOM_ID.LOGIN,
        },
      },
      isShowMenu: false,
      sidebar: { show: false },
      isShowFooter: true,
      needAsyncBasicDataInit: false, // 需要初始化基础信息(登录态)
    },
  },
  /** 登录 **/
  {
    path: "/login",
    component: () => import("@/views/Login/Index"),
    name: "登录",
    meta: {
      useLayout: false,
      needAsyncBasicDataInit: false, // 需要初始化基础信息(登录态)
    },
  },
  /** crm落地页 **/
  {
    path: "/integration-crm",
    component: () => import("@/views/IntegrationCRM/Index"),
    meta: {
      breadcrumb: { name: "全部应用" },
      header: {
        type: HEADER_TYPE.SEARCH,
      },
      isShowMenu: true,
      isShowFooter: true,
      needAsyncBasicDataInit: true, // 需要初始化基础信息(登录态)
    },
    children: [
      {
        path: "/",
        name: "集成CRM",
        component: () => import("@/views/IntegrationCRM/IntegrationCRMView"),
        meta: {
          isShowMenu: true,
          breadcrumb: { name: "集成CRM" },
          sidebar: { show: true, auto_bay: [] },
        },
      },
    ],
  },
  /** 广告页/落地页 **/
  {
    path: "/ad",
    component: () => import("@/views/Ad/Index"),
    name: "ad",
    meta: {
      useLayout: false,
    },
    children: [
      {
        path: "register-2401",
        name: "register-2401",
        component: () => import("@/views/Ad/Register_2401.vue"),
        meta: {},
      },
      {
        path: "register-2402",
        name: "register-2402",
        component: () => import("@/views/Ad/Register_2402.vue"),
        meta: {},
      },
      {
        path: "register-2403",
        name: "register-2403",
        component: () => import("@/views/Ad/Register_2403.vue"),
        meta: {},
      },
      {
        path: "register-2404",
        name: "register-2404",
        component: () => import("@/views/Ad/Register_2404.vue"),
        meta: {},
      },
    ],
  },
  // 错误路由时通配符跳转
  {
    path: "*",
    name: "",
    meta: {
      redirect_url: USER_CENTER_URL, // 用在了路由守卫处
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes,
});

// router.afterEach((to) => {
//   if (to.path === "/login") {
//     stationWideStatistics();
//   }
// });

router.beforeEach(async (to, from, next) => {
  if (ROUTE_LEAVE_CONFIRM.includes(to.path)) {
    browserLeaveTips.addEventListener();
  } else {
    browserLeaveTips.removeEventListener();
  }

  if (ROUTE_LEAVE_CONFIRM.includes(from.path)) {
    if (to.hash === "#confirmed") {
      next();
    } else {
      await LibMsgBox({
        title: "确认离开当前页面？",
        message: "您所做的更改可能未保存",
        type: "warning",
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        confirmButtonText: "离开",
        cancelButtonText: "取消",
      });
    }
  }
  switch (to.path) {
    case USER_CENTER_SEARCH_URL: // 大搜重构
      /** 跳转到老大搜 **/
      window.location.replace(OLD_USER_CENTER_SEARCH_URL + window.location.search);
      break;
    case USER_CENTER_URL: // 个人中心
    case BUSINESS_OPPORTUNITY_URL: // 找商机
    case SUBSCRIBE_CENTER_URL: // 订阅中心
    case TRADE_CENTER_URL: // 交易中心
    case ACCOUNT_MANAGE_URL: // 账户管理
      /** 跳转到老个人中心 **/
      window.location.replace(OLD_USER_CENTER_URL);
      break;
    case SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL: // 订阅中心 - 订阅管理
    case SUBSCRIBE_CENTER_SUBSCRIBE_CREATE_URL: // 订阅中心 - 新增订阅
      /** 跳转到老订阅管理 **/
      window.location.replace(OLD_SUBSCRIBE_CENTER_SUBSCRIBE_MANAGE_URL);
      break;
  }
  const parent_route = to.matched[0];
  /** 如存在重定向链接，则跳走 **/
  if (to && to.meta && to.meta.redirect_url) return (window.location.href = to.meta.redirect_url);
  /** 路由发生变化，修改useLayout **/
  const useLayout = Object.prototype.hasOwnProperty.call(to.meta, "useLayout")
    ? to.meta.useLayout
    : Object.prototype.hasOwnProperty.call(parent_route.meta, "useLayout")
    ? parent_route.meta.useLayout
    : true;
  store.commit("layout/updateUseLayout", useLayout);
  /** 路由发生变化，修改pageTitle **/
  store.commit("layout/updatePageTitle", to.name || parent_route.name);
  /** 路由发生变化，修改header类型 **/
  const header = to.meta.header || parent_route.meta.header;
  store.commit("layout/updateHeader", header);
  /** 路由发生变化，修改路由记录 **/
  const routeRecords = to.matched;
  store.commit("layout/updateRouteRecords", routeRecords);
  /** 路由发生变化，修改menu可见性 **/
  store.commit("layout/updateIsShowMenu", to.meta.isShowMenu);
  /** 路由发生变化，修改sidebar可见性 **/
  const sidebar = to.meta.sidebar || parent_route.meta.sidebar;
  store.commit("layout/updateSidebar", sidebar);
  /** 路由发生变化，修改footer可见性 **/
  const isShowFooter = to.meta.isShowFooter || parent_route.meta.isShowFooter;
  store.commit("layout/updateIsShowFooter", isShowFooter);
  /** 路由发生变化，监听 needAsyncBasicDataInit，拉数据 **/
  const needAsyncBasicDataInit = to.meta.needAsyncBasicDataInit || parent_route.meta.needAsyncBasicDataInit;
  const needAsyncBasicDataInitFrom =
    from.meta.needAsyncBasicDataInit || (from.matched[0] && from.matched[0].meta.needAsyncBasicDataInit);
  // 需要初始化基础信息(登录态)
  if (needAsyncBasicDataInit) {
    // 来自外部 或 来自内部的非登录态页面
    if (from.fullPath === "/" || !needAsyncBasicDataInitFrom) {
      await systemInit.asyncBasicDataInit();
    }
  }

  if (to.path) {
    if (window._hmt) {
      window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
    }
  }
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  next();
});

export default router;
